var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page"},[_c('NavSideBar',{attrs:{"module":"talent_manager"}}),_c('v-main',{staticClass:"content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }